import React from 'react';

const LockerFullModal = ({
  isOpen,
  prize,
  lockerSummary,
  onShipLocker,
  onExpandLocker,
  lockerActionPending,
  shippingPending,
  lockerExpansionLimitReached,
  originOffset = null,
  isMobile = false,
}) => {
  if (!isOpen || !prize || !lockerSummary) {
    return null;
  }

  const prizeName = prize?.name || 'Mystery prize';
  const prizeImage =
    typeof prize?.imageUrl === 'string' && prize.imageUrl.trim().length > 0
      ? prize.imageUrl.trim()
      : '/assets/ponpon-logo.svg';
  const prizeRarity = prize?.rarity ? prize.rarity.toString().toUpperCase() : null;
  const previewItems = lockerSummary?.previewItems ?? [];
  const filledCount = lockerSummary?.filled ?? previewItems.length;
  const maxSlots = lockerSummary?.max ?? Math.max(previewItems.length, filledCount, 8);

  const modalStyle = originOffset
    ? {
        '--modal-origin-x': `${originOffset.x}px`,
        '--modal-origin-y': `${originOffset.y}px`,
      }
    : undefined;

  const overlayClasses = isMobile
    ? 'fixed inset-x-0 top-[var(--mobile-header-offset,3.25rem)] bottom-0 z-50 flex items-start justify-center bg-ponpon-navy/40 px-4 py-6 backdrop-blur-sm'
    : 'fixed inset-0 z-50 flex items-center justify-center bg-ponpon-navy/40 px-4 py-10 backdrop-blur-sm';

  return (
    <div className={overlayClasses} role="dialog" aria-modal="true" aria-labelledby="locker-full-title">
      <div
        className="modal-appear relative w-full max-w-3xl overflow-hidden rounded-3xl border border-white/70 bg-white/95 p-6 shadow-[0_22px_55px_rgba(30,35,51,0.3)]"
        style={modalStyle}
      >
        <div className="flex flex-col gap-8">
          <div className="flex flex-col items-center gap-4 text-center">
            <div className="prize-reveal-image relative flex h-28 w-28 items-center justify-center rounded-2xl">
              <img src={prizeImage} alt={prizeName} className="max-h-24 w-auto object-contain" />
            </div>
            <div className="space-y-2">
              <h2 id="locker-full-title" className="text-2xl font-semibold text-ponpon-navy">
                Your locker is full
              </h2>
              <p className="text-sm text-ponpon-navy/70">
                We're holding "
                <strong>{prizeName}</strong>
                ". Choose how you want to claim it.
              </p>
            </div>
            {prizeRarity ? (
              <span className="inline-block rounded-full border border-ponpon-navy/15 bg-ponpon-navy/5 px-3 py-1 text-xs font-semibold text-ponpon-navy/70">
                {prizeRarity}
              </span>
            ) : null}
          </div>

          <div className="flex flex-col gap-5">
            <div className="rounded-2xl bg-ponpon-navy/5 p-4 text-sm text-ponpon-navy/70">
              <p className="font-medium text-ponpon-navy">
                Your Current Locker ({filledCount}/{maxSlots})
              </p>
              <div className="mt-3 grid grid-cols-4 justify-items-center gap-2">
                {previewItems.map((item) => {
                  const lockerPrize = item?.prize || item;
                  const name = lockerPrize?.name || 'Locker prize';
                  const image =
                    typeof lockerPrize?.imageUrl === 'string' && lockerPrize.imageUrl.trim().length > 0
                      ? lockerPrize.imageUrl.trim()
                      : '/assets/ponpon-logo.svg';
                  const key = item?.id || lockerPrize?.id || `${name}-${item?.timestamp || ''}`;
                  return (
                    <div
                      key={key}
                      className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl"
                    >
                      <img src={image} alt={name} className="max-h-full max-w-full object-contain" />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="grid gap-3 sm:grid-cols-2">
              <button
                type="button"
                onClick={onShipLocker}
                disabled={lockerActionPending || shippingPending}
                className="inline-flex items-center justify-center rounded-full border border-ponpon-coral/40 bg-white px-4 py-2.5 text-sm font-semibold text-ponpon-coral shadow-sm transition hover:-translate-y-0.5 hover:bg-ponpon-coral/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-coral/50 disabled:translate-y-0 disabled:opacity-70"
              >
                {shippingPending ? 'Processing…' : 'Ship My Current Locker'}
              </button>
              <button
                type="button"
                onClick={lockerExpansionLimitReached ? undefined : onExpandLocker}
                disabled={lockerActionPending || lockerExpansionLimitReached}
                className={`inline-flex items-center justify-center rounded-full px-4 py-2.5 text-sm font-semibold shadow-sm transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ponpon-coral/60 disabled:translate-y-0 disabled:opacity-70 ${
                  lockerExpansionLimitReached
                    ? 'cursor-not-allowed border border-ponpon-navy/20 bg-white text-ponpon-navy/40'
                    : 'bg-ponpon-coral text-white shadow-[0_12px_26px_rgba(226,58,50,0.28)] hover:-translate-y-0.5 hover:bg-[#E23A32]'
                }`}
              >
                {lockerExpansionLimitReached
                  ? 'Locker Expansion Maxed'
                  : lockerActionPending
                  ? 'Opening checkout…'
                  : 'Unlock 4 Extra Slots ($1.99)'}
              </button>
            </div>
            <p className="text-xs text-ponpon-navy/55">
              Ship your current locker for free. Expand four extra slots until your next shipment.
              <br />
              Shipping clears your current locker and moves this prize inside.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockerFullModal;

